module.exports = __webpack_public_path__ + "img/safety.655a0e7c.svg";